<template>
  <b-form-group :class="`password-group-${name}`" label-for="password">
    <slot name="txtBefore"></slot>
    <b-row>
      <b-col md="" cols="12" class="label">
        <label class="mandatory d-inline-block" :for="inputId">
          <slot name="lblPassword">Passwort</slot>
        </label>
      </b-col>
      <b-col md="" cols="12">
        <b-form-input
          :id="inputId"
          :name="name"
          type="password"
          required
          aria-required="true"
          @input="$v.password.$touch"
          :state="isValid('password')"
          v-model="password_"
        ></b-form-input>
        <b-form-invalid-feedback v-if="hasFeedback" :id="`${name}-live-feedback`">
          <ul>
            <li v-for="invalid in invalidFeedbackValidations" :key="invalid">
              <slot :name="`${invalid}Invalid`"></slot>
            </li>
          </ul>
        </b-form-invalid-feedback>
      </b-col>
    </b-row>
    <slot name="txtAfter"></slot>
  </b-form-group>
</template>

<script>
import syncProperty from '../../../../mixins/syncProperty'
import isValid from '../../../../mixins/isValid'
import { validationMixin } from 'vuelidate'
import { sameAs, required } from 'vuelidate/lib/validators'

const noValidate = (password) => true

export default {
  name: 'Password',
  mixins: [
    validationMixin,
    isValid,
    syncProperty('password', 'password_')
  ],
  methods: {
    async reset () {
      this.password_ = null
      await this.$v.password.$reset()
    }
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  props: {
    // name to identify is multiple are used in the same component
    name: {
      type: String,
      default: 'password'
    },
    // is validation required, might be false, when an old password needs to be entered
    validate: {
      type: Boolean,
      default: true
    },
    validateSameAs: {
      type: String,
      default: null
    }
  },
  computed: {
    hasFeedback () {
      return this.invalidFeedbackValidations.length > 0
    },
    inputId () {
      return `${this.name}-password` // Dynamische ID basierend auf dem Namen
    },
    // only show feedback for filled slots so we do not have empty bullets
    invalidFeedbackValidations () {
      return this.invalidPasswordValidations.filter(check => {
        return this.$slots[`${check}Invalid`] !== undefined
      })
    },
    // list of all validations that were not correct on the password
    invalidPasswordValidations () {
      return Object.keys(this.$v.password.$params)
        .filter(fieldName => this.$v.password[fieldName] === false)
    },
    validationRules () {
      if (this.validate === false) {
        return noValidate
      }
      return (this.$config?.validation?.validatePassword) || noValidate
    },
    sameAsValidation: function () {
      if (this.validateSameAs == null || this.validateSameAs === '') {
        return noValidate
      }
      return sameAs(function () {
        return this.validateSameAs
      })
    }
  },
  validations () {
    return {
      password: {
        required,
        passwordValidation: this.validationRules,
        sameAs: this.sameAsValidation
      }
    }
  }
}
</script>
